<template>
  <label class="customRadio">
    <input
      class="customRadio-input"
      type="radio"
      :checked="checked"
      :value="value"
      :disabled="disabled"
      @change="$emit('input', value)"
    >
    <span class="customRadio-control" />
    <span class="customRadio-text">
      <slot />
      <span class="customRadio-hint">{{ hint }}</span>
    </span>
  </label>
</template>

<script>
  export default {
    model: {
      prop: 'checkedValue',
      event: 'input',
    },
    props: {
      value: [Object, String, Number, Boolean],
      checkedValue: [Object, String, Number, Boolean],
      disabled: Boolean,
      hint: String,
    },
    computed: {
      checked() {
        return this.checkedValue === this.value;
      },
    },
  };
</script>

<style scoped>
  .customRadio {
    display: inline-block;
    margin-bottom: 16px;
    font-size: 14px;
  }
  .customRadio-input {
    position: absolute;
    visibility: hidden;
  }
  .customRadio-control {
    display: inline-block;
    vertical-align: text-bottom;
    margin-bottom: 2px;
    width: 16px;
    height: 16px;
    background: white;
    border: 2px solid #999999;
    border-radius: 8px;
  }
  .customRadio-input:checked ~ .customRadio-control::before {
    content: '';
    display: block;
    margin: 3px;
    width: 6px;
    height: 6px;
    background: #999999;
    border-radius: 3px;
  }
  .customRadio-input:disabled ~ * {
    opacity: .5;
  }
  .customRadio-text {
    margin-left: 12px;
  }
  .customRadio-hint {
    display: block;
    margin-left: 32px;
    margin-top: 8px;
    margin-bottom: 8px;
    color: #A7A7A7;
  }
</style>
